import { render, staticRenderFns } from "./DfConfirm.vue?vue&type=template&id=7cfcd41e&"
import script from "./DfConfirm.vue?vue&type=script&lang=js&"
export * from "./DfConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports